export const jobStatuses = {
  "0": "Noise",
  "1": "New Booking",
  "2": "Failed Pending Retry",
  "3": "New Quote",
  "4": "New Failed",
  "5": "Awaiting Requisition",
  "6": "Unallocated",
  "7": "Allocated",
  "8": "In Progress",
  "9": "Pulled for Parts - Awaiting Parts",
  "10": "Completed",
  "11": "Cancelled Booking",
  "12": "Cancelled Quote",
  "13": "Failed Booking",
  "14": "Failed Quote",
  "15": "In Debt",
  "16": "Written Off",
  "17": "Confirmed",
  "18": "AA Cancelled",
  "19": "Auto SMS",
  "20": "Searching Engineer",
  "21": "New Booking with Issues",
  "22": "New Quote with Issues",
  "23": "Received Requisition",
  "24": "ETQ Small Job Free Quote",
  "25": "Cancellation Request",
  "26": "Engineer To Quote",
  "27": "No Charge Go Back",
  "28": "RIGHTIO Call Me Back",
  "29": "Debt Recovery",
  "30": "Claim Validation",
  "31": "Claim Cancelled",
  "32": "Quote Extra Work Closed Down",
  "33": "Pending Payment",
  "34": "Boiler Lead",
  "35": "Lost Contact",
  "36": "Cancellation Request",
  "37": "Pulled for Parts - Parts Arrived",
  "38": "Pre Allocated",
  "39": "Payment Issue",
  "40": "Pre Allocated Appt Verified",
  "41": "Completed - Awaiting Payment",
  "42": "Active Quote",
  "43": "New Call Me Back",
  "44": "Awaiting Authorisation",
  "45": "Awaiting Contact from Customer",
  "46": "Credit Control Chase Debt",
  "47": "Credit Control Judgment Entered",
  "48": "Auto Allocated",
  "49": "Credit Control LBA First",
  "50": "Credit Control Debt Complaint",
  "51": "Credit Control Summons Issued",
  "52": "Credit Control Legal",
  "53": "Quote Site Visit Completed",
  "54": "CCJ Enforcement",
  "55": "Credit Control Arrangement to Pay",
  "56": "Go Back Validation",
  "57": "Pre-Alloc Next Job",
  "58": "Deposit Refunded",
  "59": "Failed CC Quote",
  "60": "Failed Go Back",
  "61": "Failed Upsell / Further Work",
  "62": "Pulled for Parts - Pending Payment",
  "63": "Job Escalation",
  "64": "Credit Control LBA Final",
  "65": "Cash / Cheque Review",
  "66": "Invoice Review",
  "96": "Technical or IT Issue",
  "97": "Auto Offer",
  "98": "Engineer On Route",
  "99": "In Progress",
  "100": "Pre Auto Offer",
  "101": "Awaiting Customer Confirmation",
  "110": "Completed - Chargeback",
};
